<template>
  <div class="w-full flex bg-white new-zag border-round">
    <el-dialog
      :visible.sync="centerDialogVisible"
      custom-class="el-header-hide"
      width="30%"
      center
      class="edit-pop"
    >
      <div class="flex justify-center items-center">
        <div>
          <div class="flex justify-center">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
              class="w-32 h-32"
            />
          </div>
          <div class="text-center mt-3">
            <h4 class="font-semibold text-dark text-2xl">
              Before we proceed further...
            </h4>
            <p class="fsize12 col-4f">You're this closed to completion</p>
          </div>
          <div class="grid grid-cols-2 gap-4 mt-4">
            <vs-button
              type="success"
              @click="handleClick('profile-v')"
              class="bg-success rounded-lg border-0 text-white font-semibold py-3 fsize12 px-4 sm-fsize14"
            >
              Make some changes
            </vs-button>
            <vs-button
              type="primary"
              @click="handleClick('dashboard')"
              class="bg-primary border-0 rounded-lg text-white font-semibold py-3 fsize14 px-2 sm-fsize14"
            >
              Proceed
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <div class="flex w-full">
      <div class="w-11/12 px-16 py-12">
        <h1 class="text-3xl mb-0 text-dark font-semibold">Brand Profile</h1>
        <p class="fsize14 text-gray mb-0 opacity-80">
          Almost done! Enter Contact details to be displayed<br />
          on your website and brand collaterals
        </p>
        <div class="shadow-lg border-round mt-8 px-12 pt-10 pb-24 relative">
          <div>
            <small class="text-sm text-primary font-semibold">Step 5</small>
            <h1 class="fsize21 col-4f mb-0 font-semibold">Business Details</h1>
            <p class="fsize14 col-4f mb-0 opacity-80">
              Enter your business details to be displayed through your digital
              presence
            </p>
          </div>

          <div class="grid grid-cols-3 gap-4 mt-8">
            <div class="pr-4">
              <h1 class="text-xl text-primary mb-0 font-semibold">
                Business Details
              </h1>
              <p class="fsize14 col-4f mb-0 opacity-80">
                Enter Contact Information
              </p>

              <div class="input-field mt-4">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Phone Number <span class="text-danger">*</span></small
                >
                <vue-tel-input
                  :disabledFormatting="true"
                  :enabledCountryCode="true"
                  placeholder="Enter phone no"
                  name="Contact no"
                  :required="true"
                  :autoDefaultCountry="true"
                  v-model="mobile"
                  class="w-full mt-5 h-12 rounded-xl div-autowidth"
                  v-validate="'required|numeric|max:10'"
                  data-vv-validate-on="input|blur"
                  :defaultCountry="
                    `${this.selectedProject.countryCode.iso2}`
                      ? `${this.selectedProject.countryCode.iso2}`
                      : 'IN'
                  "
                  :showFlags="true"
                  :disabledFetchingCountry="true"
                  ref="countryCode"
                  :key="login.countryCode.iso2"
                  :showFlag="true"
                  @country-changed="getCountry"
                />
              </div>
              <div class="input-field mt-4">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Website URL
                </small>
                <el-input
                  type="text"
                  placeholder="www.businessname.com"
                  id="name"
                  v-model="url"
                  class="mt-2"
                  required
                />
              </div>
              <div class="input-field mt-4">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Business Email <span class="text-danger">*</span></small
                >
                <el-input
                  type="text"
                  placeholder="example@businessname.com"
                  id="name"
                  v-model="email"
                  class="mt-2"
                  required
                />
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{ email === "" ? "This Field is required" : "" }}
                </p>
              </div>
              <div class="input-field mt-4">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Business Address <span class="text-danger">*</span></small
                >
                <el-input
                  class="w-full mt-2 h128pxel"
                  type="textarea"
                  v-model="address"
                  placeholder="Enter your business address"
                  id="name"
                  required
                />
                <p v-if="submitted == true" class="fsize12 text-danger">
                  {{ address === "" ? "This Field is required" : "" }}
                </p>
              </div>
              <div class="input-field mt-4">
                <small class="fsize12 bg-white text-dark font-medium"
                  >GST Number</small
                >
                <el-input
                  class="w-full mt-2 h128pxel"
                  type="text"
                  v-model="GSTNumber"
                  placeholder="Enter your GST Number"
                  id="name"
                  required
                />
                <p
                  v-if="
                    (GSTNumber === '' && submitted === true) ||
                    (regexCheck === false && GSTNumber)
                  "
                  class="fsize12 text-danger"
                >
                  {{
                    regexCheck === false ? "Please fill proper GST number" : ""
                  }}
                </p>
              </div>
            </div>

            <div class="px-4">
              <h1 class="text-xl text-primary mb-0 font-semibold">
                Social Media
              </h1>
              <p class="fsize14 col-4f mb-0 opacity-80">
                Display your social media channels
              </p>

              <div class="input-field mt-4">
                <small class="fsize12 bg-white text-dark font-medium">
                  Instagram</small
                >
                <el-input
                  type="text"
                  placeholder="Profile Link"
                  id="name"
                  v-model="instagram"
                  class="mt-2"
                  required
                />
              </div>
              <div class="input-field mt-4">
                <small class="fsize12 bg-white text-dark font-medium">
                  Facebook</small
                >
                <el-input
                  type="text"
                  placeholder="Profile Link"
                  id="name"
                  v-model="facebook"
                  class="mt-2"
                  required
                />
              </div>
              <div class="input-field mt-4">
                <small class="fsize12 bg-white text-dark font-medium">
                  Whatsapp</small
                >
                <el-input
                  type="text"
                  placeholder="Profile Link"
                  id="name"
                  v-model="whatsapp"
                  class="mt-2"
                  required
                />
              </div>
              <div class="input-field mt-4">
                <small class="fsize12 bg-white text-dark font-medium">
                  Linkedin</small
                >
                <el-input
                  type="text"
                  placeholder="Profile Link"
                  id="name"
                  v-model="linkedin"
                  class="mt-2"
                  required
                />
              </div>
              <div class="input-field mt-4">
                <small class="fsize12 bg-white text-dark font-medium">
                  Pintrest</small
                >
                <el-input
                  type="text"
                  placeholder="Profile Link"
                  id="name"
                  v-model="pintrest"
                  class="mt-2"
                  required
                />
              </div>
            </div>

            <div class="pl-4">
              <h1 class="text-xl text-primary mb-0 font-semibold">
                Active Hours
              </h1>
              <p class="fsize14 col-4f mb-0 opacity-80">
                Specify your working Hours
              </p>
              <div class="relative mt-4">
                <small class="fsize12 bg-white text-dark font-medium"
                  >Select a Timezone</small
                >
                <el-select
                  v-model="timezone"
                  placeholder="Select"
                  class="w-full mt-2"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in options"
                    :key="`${index}-${item.name}`"
                    :label="`${item.name} ` + ' ' + ` ${item.zone}`"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="grid grid-cols-7 mt-4 checkj">
                <div class="">
                  <el-checkbox v-model="sunday">Su</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox v-model="monday">Mo</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox v-model="tuesday">Tu</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox v-model="wednesday">W</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox v-model="thursday">Th</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox v-model="friday">Fr</el-checkbox>
                </div>
                <div class="">
                  <el-checkbox v-model="saturday">Sa</el-checkbox>
                </div>
              </div>
              <div class="mt-8 flex">
                <div class="w-1/2 pr-2">
                  <small class="fsize12 bg-white text-dark font-medium"
                    >Open from</small
                  >
                  <el-time-select
                    class="w-full mt-2"
                    placeholder="Start time"
                    v-model="from"
                    :picker-options="{
                      start: '08:30',
                      step: '00:15',
                      end: '18:30',
                    }"
                  >
                  </el-time-select>
                </div>
                <div class="w-1/2 pl-2">
                  <small class="fsize12 bg-white text-dark font-medium"
                    >Closes at</small
                  >
                  <el-time-select
                    class="w-full mt-2"
                    placeholder="End time"
                    v-model="to"
                    :picker-options="{
                      start: '08:30',
                      step: '00:15',
                      end: '18:30',
                      minTime: from,
                    }"
                  >
                  </el-time-select>
                </div>
              </div>
            </div>
          </div>
          <div
            class="absolute bottom-0 margin-nichu right-0 left-0 w-full flex justify-between"
          >
            <div class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/brained-product/Default.svg"
                class="mar-left"
                @click="handleClick2('color')"
              />
            </div>
          </div>
          <div class="absolute top-0 right-0">
            <div class="cursor-pointer">
              <img
                src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/go.png"
                class="margin-newsd"
                @click="clicking"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="w-1/12 bg-primary z-20 p-1 relative">
        <div class="absolute top-0 left-0">
          <div class="grid grid-cols-1 gap-4">
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name1.png"
              class="w-full object-cover h-32"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name1.png"
              class="w-full object-cover h-32"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name1.png"
              class="w-full object-cover h-32"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name1.png"
              class="w-full object-cover h-32"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name1.png"
              class="w-full object-cover h-32"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name1.png"
              class="w-full object-cover h-32"
            />
            <img
              src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/name1.png"
              class="w-full object-cover h-32"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import time from "moment-timezone";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
export default {
  data() {
    return {
      phone: "",
      url: "",
      email: "",
      address: "",
      instagram: "",
      facebook: "",
      whatsapp: "",
      linkedin: "",
      pintrest: "",
      timezone: "",
      sunday: false,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      from: "",
      to: "",
      centerDialogVisible: false,
      options: [],
      GSTNumber: "",
      submitted: false,
      code: "",
      countryC: "",
      completed: false,
      regexCheck: false,
    };
  },
  components: {
    VueTelInput,
  },
  computed: {
    ...mapState("brandProfile", {
      brandProfile: "brandProfile",
    }),
    ...mapState("user", { selectedProject: "selectedProject" }),
    ...mapState("admin", ["login"]),
  },
  mounted() {
    // console.log(this.brandProfile);
    // let timezones = Intl.supportedValuesOf("timeZone");
    // const formattedTimeZone = Intl.supportedValuesOf("timeZone").map(
    //   (timezone) => {
    //     let timeZoneData = new Intl.DateTimeFormat("en-US", {
    //       timeZone: timezone,

    //       timeZoneName: "longOffset",
    //     });

    //     return ``

    //     console.log(timeZoneData.format(date));
    //   }
    // );

    // timezones.map(zone=>{

    // })
    this.getTimeZone();
    this.init();
    // this.IScompleted();
    // this.code = this.$refs.countryCode._data.activeCountry.dialCode;
    // console.log(this.code, "countryyyy");
  },
  watch: {
    GSTNumber(val) {
      if (val || val === null || val === "") {
        const regex = new RegExp(
          /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/
        );
        let regexData = regex.test(val);
        this.regexCheck = regexData;
      }
    },
  },
  methods: {
    getCountry(country) {
      this.code = country;
    },
    getTimeZone() {
      let data = time.tz.names();
      console.log(data);
      for (let i = 0; i < data.length; i++) {
        this.options.push({
          name: data[i],
          zone: time.tz(`${data[i]}`).format(`z (Z)`),
        });
      }
    },
    init() {
      this.mobile = this.login.mobile;
      this.url = this.brandProfile.contactDetails.url;
      this.email = this.login.email;
      this.completed = this.brandProfile.isCompleted;
      this.address = this.brandProfile.contactDetails.address;
      this.instagram = this.brandProfile.contactDetails.instagram;
      this.facebook = this.brandProfile.contactDetails.facebook;
      this.whatsapp = this.brandProfile.contactDetails.whatsapp;
      this.linkedin = this.brandProfile.contactDetails.linkedin;
      this.pintrest = this.brandProfile.contactDetails.pintrest;
      this.timezone = this.brandProfile.contactDetails.timezone;
      this.sunday = this.brandProfile.contactDetails.weekDays.sunday;
      this.monday = this.brandProfile.contactDetails.weekDays.monday;
      this.tuesday = this.brandProfile.contactDetails.weekDays.tuesday;
      this.wednesday = this.brandProfile.contactDetails.weekDays.wednesday;
      this.thursday = this.brandProfile.contactDetails.weekDays.thursday;
      this.friday = this.brandProfile.contactDetails.weekDays.friday;
      this.saturday = this.brandProfile.contactDetails.weekDays.saturday;
      this.from = this.brandProfile.contactDetails.from;
      this.to = this.brandProfile.contactDetails.to;
      this.GSTNumber = this.brandProfile.GSTNumber;
      this.countryC = this.brandProfile.contactDetails.countrycode.iso2;
    },
    clicking() {
      console.log(this.regexCheck, "Hello");
      if (
        this.email !== "" &&
        this.address !== "" &&
        this.mobile !== "" &&
        this.regexCheck === true
      ) {
        this.submitted = true;
        this.centerDialogVisible = true;
      } else {
        this.submitted = true;
        this.regexCheck = false;
        this.centerDialogVisible = false;
      }
    },
    async handleClick2(name) {
      this.$router.push({ name: name });
    },
    async handleClick(name) {
      console.log(name, "AnishKhot");
      this.submitted = true;
      this.centerDialogVisible = false;
      if (name === "dashboard") {
        // console.log();
        if (this.email !== "" && this.address !== "" && this.mobile !== "") {
          let payloadInfo = {
            contactDetails: true,
            projectId: this.selectedProject._id,
            projectName: this.selectedProject.projectName,
            mobile: this.mobile,
            url: this.url,
            email: this.email,
            address: this.address,
            instagram: this.instagram,
            facebook: this.facebook,
            whatsapp: this.whatsapp,
            linkedin: this.linkedin,
            pintrest: this.pintrest,
            timezone: this.timezone,
            sunday: this.sunday,
            monday: this.monday,
            tuesday: this.tuesday,
            wednesday: this.wednesday,
            thursday: this.thursday,
            friday: this.friday,
            saturday: this.saturday,
            from: this.from,
            to: this.to,
            GSTNumber: this.GSTNumber,
            countrycode: this.code,
            isCompleted: true,
          };
          // let payload = {};
          // if (this.GSTNumber) {
          //   Object.assign(payload, { GSTNumber: this.GSTNumber });
          // }
          // if (this.whatsapp) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { whatsapp: this.whatsapp });
          // }
          // if (this.facebook) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { facebook: this.facebook });
          // }
          // if (this.email) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { email: this.email });
          // }
          // if (this.address) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { address: this.address });
          // }
          // if (this.instagram) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { instagram: this.instagram });
          // }
          // if (this.pintrest) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { pintrest: this.pintrest });
          // }
          // if (this.linkedin) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { linkedin: this.linkedin });
          // }
          // if (this.from) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { from: this.from });
          // }
          // if (this.mobile) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { mobile: this.mobile });
          // }
          // if (this.url) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { url: this.url });
          // }
          // if (this.to) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { to: this.to });
          // }
          // if (this.timezone) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { timezone: this.timezone });
          // }
          // if (this.sunday) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { sunday: this.sunday });
          // }
          // if (this.monday) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { monday: this.monday });
          // }
          // if (this.tuesday) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { tuesday: this.tuesday });
          // }
          // if (this.wednesday) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, {
          //     wednesday: this.wednesday,
          //   });
          // }
          // if (this.thursday) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { thursday: this.thursday });
          // }
          // if (this.friday) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, {
          //     friday: this.friday,
          //   });
          // }
          // if (this.saturday) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, { weekDays: true });
          //   Object.assign(payload, { saturday: this.saturday });
          // }
          // if (this.code) {
          //   Object.assign(payload, { contactDetails: true });
          //   Object.assign(payload, {
          //     countrycode: this.code,
          //   });
          // }

          if (name === "dashboard") {
            Object.assign(payloadInfo, { isCompleted: true });
            console.log(payloadInfo);
          }
          let data = await this.$store.dispatch(
            "brandProfile/uploadBrandProfile",
            payloadInfo
          );
          this.$router.push({ name: name });
        } else {
          this.centerDialogVisible = false;
        }
      } else {
        this.$router.push({ name: name });
      }
    },
    IScompleted() {
      if (this.completed === true) {
        console.log(this.completed, "complteds");
        this.$router.push({ name: "dashboard" });
      }
    },
  },
};
</script>
<style>
.el-select-dropdown.el-popper {
  z-index: 99999 !important;
}
</style>
